import { ArrayAction } from "@vp/shared/utilities";
import { EventLogFilter } from "../..";

export class SetFilter {
  public static readonly type = "[Event Logs] Set Filter";
  constructor(
    public filter: Partial<EventLogFilter>,
    public arrayAction: ArrayAction = "replace"
  ) {}
}

export class ResetState {
  public static readonly type = "[Event Logs] Reset State";
}

export class GetUserEventLogs {
  public static readonly type = "[Event Logs] Get User Event Logs";
  constructor(public filter: Readonly<Partial<EventLogFilter>>) {}
}
